
// Deep-link anchor scroll correction — pages with lazy-loaded images
// (loading="lazy", no reserved aspect-ratio) are shorter at DOMContentLoaded
// than after every image finishes loading, so the browser's native #hash
// jump (which runs once, early) lands short of the real target once those
// images push the rest of the page down. Re-run the same jump after
// window 'load' (all resources in) to correct for that; no-op if the
// target's already in view or there's no hash.
window.addEventListener('load',function(){
if(!window.location.hash){return;}
var target=document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
if(target){ target.scrollIntoView({block:'start'}); }
});

document.addEventListener('DOMContentLoaded',()=>{

if(window.gsap){
gsap.registerPlugin(ScrollTrigger);

gsap.from('.hero-kicker',{
y:20,
opacity:0,
duration:.7,
ease:'power3.out'
});

gsap.from('.hero-title',{
y:80,
opacity:0,
duration:1.2,
ease:'power4.out'
});

gsap.from('.hero-copy',{
y:30,
opacity:0,
duration:.9,
delay:.25
});

gsap.from('.hero-content .primary-btn',{
y:20,
opacity:0,
duration:.7,
delay:.45
});

if(document.querySelector('.airy2-hero')){
var airyTl=gsap.timeline({defaults:{ease:'power3.out'}});
airyTl.from('.airy2-kicker',{y:20,opacity:0,duration:.6})
.from('.airy2-title',{y:50,opacity:0,duration:.9},'-=.35')
.from('.airy2-tagline',{y:20,opacity:0,duration:.7},'-=.55')
.from('.airy2-hero-btn',{y:20,opacity:0,duration:.6},'-=.45')
.from('.airy2-hero-image img',{scale:.85,opacity:0,duration:1.1,ease:'power2.out'},'-=.9');
}

/* Hero Ken Burns — slow continuous zoom on active slide */
if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
document.querySelectorAll('.hero-slide img').forEach(function(img, i){
gsap.fromTo(img,
{scale:1},
{scale:1.12, duration:9, ease:'none', repeat:-1, yoyo:true, delay:i*0.15}
);
});
}

/* Premium staggered reveal — groups siblings so grids/rows cascade together instead of firing independently */
var revealItems = gsap.utils.toArray('.reveal-item, .tl-reveal');
var revealGroups = new Map();
revealItems.forEach(function(item){
var parent = item.parentElement;
if(!revealGroups.has(parent)){ revealGroups.set(parent, []); }
revealGroups.get(parent).push(item);
});
revealGroups.forEach(function(items){
gsap.set(items, {clearProps:'opacity,transform,filter'});
gsap.from(items,{
y:56,
opacity:0,
scale:.96,
duration:1.1,
ease:'power3.out',
stagger:{each:0.09, from:'start'},
scrollTrigger:{
trigger: items[0],
start:'top 90%',
once:true
},
onComplete:function(){
gsap.set(items, {clearProps:'all'});
}
});
});

/* Image reveal wipe — clip-path sweep for key showcase images */
gsap.utils.toArray('.split-image img, .campaign-banner img, .campaign-banner-video, .collection-hero-img, .collection-hero-video').forEach(function(img){
gsap.fromTo(img,
{clipPath:'inset(0 0 0 100%)'},
{
clipPath:'inset(0 0 0 0%)',
duration:1.3,
ease:'power4.inOut',
scrollTrigger:{trigger:img, start:'top 85%', once:true}
}
);
});

/* Parallax on tagged images — moves slower/faster than scroll for depth */
gsap.utils.toArray('.split-image img, .campaign-banner img').forEach(function(img){
gsap.to(img,{
yPercent:14,
ease:'none',
scrollTrigger:{
trigger:img,
start:'top bottom',
end:'bottom top',
scrub:true
}
});
});

/* Magnetic buttons — subtle pull toward cursor within radius, snap back on leave.
   Also drives a cursor-follow glow (background-image radial-gradient paints
   behind text automatically, no extra DOM/z-index needed). */
if(window.matchMedia('(hover: hover) and (pointer: fine)').matches){
document.querySelectorAll('.primary-btn, .add-cart-btn, .od-return-btn, .rr-submit-btn, .quick-add-btn').forEach(function(btn){
var strength = 0.35;
var cachedRect = null;
var glowColor = 'rgba(255,255,255,.28)';
if(getComputedStyle(btn).backgroundColor === 'rgba(0, 0, 0, 0)'){ glowColor = 'rgba(51,63,72,.14)'; }
btn.addEventListener('mouseenter', function(){
cachedRect = btn.getBoundingClientRect();
});
btn.addEventListener('mousemove', function(e){
if(!cachedRect){ cachedRect = btn.getBoundingClientRect(); }
var relX = e.clientX - cachedRect.left - cachedRect.width/2;
var relY = e.clientY - cachedRect.top - cachedRect.height/2;
gsap.to(btn,{x:relX*strength, y:relY*strength, duration:.4, ease:'power2.out'});
var gx = e.clientX - cachedRect.left;
var gy = e.clientY - cachedRect.top;
btn.style.backgroundImage = 'radial-gradient(160px circle at '+gx+'px '+gy+'px, '+glowColor+', transparent 70%)';
});
btn.addEventListener('mouseleave', function(){
cachedRect = null;
gsap.to(btn,{x:0, y:0, duration:.5, ease:'elastic.out(1,.4)'});
btn.style.backgroundImage = '';
});
});
}

}

/* Lazy-load 3D hippo badges (Three.js) only when a container for one exists on
   the page, after idle, so they never compete with LCP/critical rendering.
   Two variants share the same Three.js load: the homepage hero badge
   (braclo3dBadge) and the "Earn B Coins" gold coin badge, which now has
   multiple simultaneous instances per page (product page + mobile header) -
   badge3d-coin.js finds all of them itself via .bcoins-3d-badge, so this
   loader only needs to know whether at least one exists. */
var badge3dEl = document.getElementById('braclo3dBadge');
var badge3dCoinEl = document.querySelector('.bcoins-3d-badge');
if((badge3dEl || badge3dCoinEl) && window.WebGLRenderingContext){
var loadBadge3d = function(){
var loadScript = function(src){
var s = document.createElement('script');
s.src = src;
document.body.appendChild(s);
};
var afterThree = function(){
if(badge3dEl){ loadScript(window.BRACLO_BADGE3D_URL); }
if(badge3dCoinEl){ loadScript(window.BRACLO_BADGE3D_COIN_URL); }
};
if(window.THREE){ afterThree(); return; }
var s1 = document.createElement('script');
s1.src = 'https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.min.js';
s1.onload = afterThree;
document.body.appendChild(s1);
};
if('requestIdleCallback' in window){ requestIdleCallback(loadBadge3d, {timeout:2500}); }
else { setTimeout(loadBadge3d, 1200); }
}

var transparentHeader=document.querySelector('.lux-header-transparent');
if(transparentHeader){
var toggleHeaderScrolled=function(){
transparentHeader.classList.toggle('scrolled',window.scrollY>80);
};
toggleHeaderScrolled();
window.addEventListener('scroll',toggleHeaderScrolled,{passive:true});
}

var productForm=document.getElementById('product-form');
var sizeRow=document.getElementById('sizeRow');
var lowStockNote=document.getElementById('lowStockNote');

function updateLowStockNote(){
if(!lowStockNote){return;}
var checked=sizeRow ? sizeRow.querySelector('.size-radio:checked') : null;
var qty=checked ? parseInt(checked.dataset.inventory,10) : NaN;
if(checked && checked.dataset.tracked==='shopify' && !isNaN(qty) && qty>0 && qty<5){
lowStockNote.textContent='Only '+qty+' left in this size!';
lowStockNote.classList.add('show');
}else{
lowStockNote.textContent='';
lowStockNote.classList.remove('show');
}
}

if(productForm && sizeRow){
productForm.addEventListener('submit',function(e){
e.preventDefault();
var checked=sizeRow.querySelector('.size-radio:checked');
if(!checked){
sizeRow.classList.add('error');
var sizeError=document.getElementById('sizeError');
if(sizeError){sizeError.classList.add('show');}
sizeRow.scrollIntoView({behavior:'smooth',block:'center'});
setTimeout(function(){sizeRow.classList.remove('error');},400);
return;
}
addToCartAjax(productForm);
});
sizeRow.addEventListener('change',function(){
sizeRow.classList.remove('error');
var sizeError=document.getElementById('sizeError');
if(sizeError){
sizeError.textContent='Please select a size.';
sizeError.classList.remove('show');
}
updateLowStockNote();
});
sizeRow.addEventListener('click',function(e){
var pill=e.target.closest('.size-pill.sold-out');
if(!pill){return;}
var sizeError=document.getElementById('sizeError');
if(sizeError){
sizeError.textContent='This size is out of stock.';
sizeError.classList.add('show');
}
var backInStockBox=document.getElementById('backInStockBox');
if(backInStockBox){
backInStockBox.dataset.variantId=pill.dataset.variantId;
backInStockBox.classList.add('show');
var statusEl=document.getElementById('backInStockStatus');
if(statusEl){statusEl.textContent='';statusEl.className='back-in-stock-status';}
}
});
}
updateLowStockNote();

document.addEventListener('submit',function(e){
var form=e.target;
if(form.classList && form.classList.contains('quick-add-form')){
e.preventDefault();
handleQuickAdd(form);
}
});

bindCartDrawerEvents();
markWishlistIcons();
updateWishlistCount();
applyEarlyAccessGating();

document.querySelectorAll('.product-card').forEach(function(card){
var video=card.querySelector('.product-hover-video');
if(!video){return;}
card.addEventListener('mouseenter',function(){
var playPromise=video.play();
if(playPromise!==undefined){playPromise.catch(function(){});}
});
card.addEventListener('mouseleave',function(){
video.pause();
video.currentTime=0;
});
});

var stickyCart=document.querySelector('.mobile-sticky-cart');
var footer=document.querySelector('.lux-footer');
if(stickyCart && footer && window.IntersectionObserver){
var footerObserver=new IntersectionObserver(function(entries){
entries.forEach(function(entry){
stickyCart.classList.toggle('hide',entry.isIntersecting);
});
},{root:null,threshold:0});
footerObserver.observe(footer);
}

var autoplayVideos=document.querySelectorAll('.airy2-fabric-video, .made-right-video, .about-film-video');
if(autoplayVideos.length && window.IntersectionObserver){
var videoObserver=new IntersectionObserver(function(entries){
entries.forEach(function(entry){
var v=entry.target;
if(entry.isIntersecting){
var playPromise=v.play();
if(playPromise!==undefined){
playPromise.catch(function(){});
}
}else{
v.pause();
}
});
},{threshold:.25});
autoplayVideos.forEach(function(v){
v.muted=true;
videoObserver.observe(v);
});
}

var heroSlidesTrack=document.getElementById('heroSlides');
if(heroSlidesTrack){
var heroSlides=heroSlidesTrack.querySelectorAll('.hero-slide');
var heroDots=document.querySelectorAll('#heroDots .hero-dot');
var heroSpeed=(parseFloat(heroSlidesTrack.dataset.speed)||5)*1000;
var heroIdx=0;
if(heroSlides.length>1){
setInterval(function(){
heroSlides[heroIdx].classList.remove('active');
if(heroDots[heroIdx]){heroDots[heroIdx].classList.remove('active');}
heroIdx=(heroIdx+1)%heroSlides.length;
heroSlides[heroIdx].classList.add('active');
if(heroDots[heroIdx]){heroDots[heroIdx].classList.add('active');}
},heroSpeed);
}
}

var bar=document.getElementById('announcementBar');
if(bar){
var spans=bar.querySelectorAll('span');
var idx=0;
if(spans.length>1){
setInterval(function(){
spans[idx].classList.remove('active');
idx=(idx+1)%spans.length;
spans[idx].classList.add('active');
},3200);
}
}

});

function openFilterPanel(){
var panel=document.getElementById('filterPanel');
var overlay=document.getElementById('filterOverlay');
if(panel){panel.classList.add('open');}
if(overlay){overlay.classList.add('open');}
}

function closeFilterPanel(){
var panel=document.getElementById('filterPanel');
var overlay=document.getElementById('filterOverlay');
if(panel){panel.classList.remove('open');}
if(overlay){overlay.classList.remove('open');}
}

function openMobileNav(){
var panel=document.getElementById('mobileNavPanel');
var overlay=document.getElementById('mobileNavOverlay');
if(panel){panel.classList.add('open');}
if(overlay){overlay.classList.add('open');}
document.body.style.overflow='hidden';
}

function openSizeGuide(){
var overlay=document.getElementById('sizeGuideOverlay');
if(overlay){overlay.classList.add('open');}
document.body.style.overflow='hidden';
}

function closeSizeGuide(){
var overlay=document.getElementById('sizeGuideOverlay');
if(overlay){overlay.classList.remove('open');}
document.body.style.overflow='';
}

function submitBackInStock(){
var box=document.getElementById('backInStockBox');
var emailInput=document.getElementById('backInStockEmail');
var btn=document.getElementById('backInStockBtn');
var statusEl=document.getElementById('backInStockStatus');
if(!box || !emailInput || !btn || !statusEl){return;}
var email=emailInput.value.trim();
var emailPattern=/^[^\s@]+@[^\s@]+\.[^\s@]+$/;
if(!emailPattern.test(email)){
statusEl.textContent='Please enter a valid email.';
statusEl.className='back-in-stock-status error';
return;
}
btn.disabled=true;
statusEl.textContent='Submitting…';
statusEl.className='back-in-stock-status';
fetch('https://chat-api.braclo.in/api/back-in-stock/subscribe',{
method:'POST',
headers:{'Content-Type':'application/json'},
body:JSON.stringify({
productId:box.dataset.productId,
variantId:box.dataset.variantId,
email:email
})
})
.then(function(res){return res.json().then(function(data){return {ok:res.ok,data:data};});})
.then(function(result){
if(!result.ok){throw new Error((result.data && result.data.error) || 'Something went wrong.');}
statusEl.textContent="You'll get an email when this size is back.";
statusEl.className='back-in-stock-status success';
emailInput.disabled=true;
})
.catch(function(err){
statusEl.textContent=err.message || 'Something went wrong. Please try again.';
statusEl.className='back-in-stock-status error';
btn.disabled=false;
});
}

function switchSizeUnit(btn,unit){
document.querySelectorAll('.size-guide-unit-btn').forEach(function(b){b.classList.remove('active');});
btn.classList.add('active');
document.querySelectorAll('.size-guide-table td[data-in]').forEach(function(td){
td.textContent = unit==='cm' ? td.dataset.cm : td.dataset.in;
});
}

function openSizePredictor(){
var overlay=document.getElementById('sizePredictorOverlay');
if(overlay){overlay.classList.add('open');}
document.body.style.overflow='hidden';
}

function closeSizePredictor(){
var overlay=document.getElementById('sizePredictorOverlay');
if(overlay){overlay.classList.remove('open');}
document.body.style.overflow='';
}

function selectFitPreference(btn){
document.querySelectorAll('.sp-fit-btn').forEach(function(b){b.classList.remove('active');});
btn.classList.add('active');
}

function readSizeChartFromDom(){
var table=document.querySelector('#sizeGuideOverlay .size-guide-table');
if(!table){return [];}
var headers=[];
table.querySelectorAll('thead th').forEach(function(th,i){
if(i===0){return;}
headers.push(th.textContent.trim().toLowerCase());
});
var chart=[];
table.querySelectorAll('tbody tr').forEach(function(tr){
var cells=tr.querySelectorAll('td');
if(!cells.length){return;}
var row={size:cells[0].textContent.trim()};
for(var i=1;i<cells.length;i++){
var key=headers[i-1];
if(!key){continue;}
var cmVal=cells[i].getAttribute('data-cm');
var val=cmVal!==null ? parseFloat(cmVal) : parseFloat(cells[i].textContent);
if(!isNaN(val)){row[key]=val;}
}
chart.push(row);
});
return chart;
}

function submitSizePredictor(){
var heightInput=document.getElementById('spHeight');
var weightInput=document.getElementById('spWeight');
var errorEl=document.getElementById('spError');
var btn=document.getElementById('spSubmitBtn');
if(!heightInput || !weightInput || !errorEl || !btn){return;}
var height=parseFloat(heightInput.value);
var weight=parseFloat(weightInput.value);
if(!height || height<100 || height>230){
errorEl.textContent='Please enter a valid height in cm.';
return;
}
if(!weight || weight<30 || weight>200){
errorEl.textContent='Please enter a valid weight in kg.';
return;
}
var fitBtn=document.querySelector('.sp-fit-btn.active');
var fitPreference=fitBtn ? fitBtn.dataset.fit : 'Regular';
var chart=readSizeChartFromDom();
if(!chart.length){
errorEl.textContent='Size chart is unavailable for this product.';
return;
}
errorEl.textContent='';
btn.disabled=true;
btn.textContent='Predicting…';
fetch('https://chat-api.braclo.in/api/size-predictor/predict',{
method:'POST',
headers:{'Content-Type':'application/json'},
body:JSON.stringify({height:height,weight:weight,fitPreference:fitPreference,chart:chart})
})
.then(function(res){return res.json().then(function(data){return {ok:res.ok,data:data};});})
.then(function(result){
btn.disabled=false;
btn.textContent='Predict My Size';
if(!result.ok){throw new Error((result.data && result.data.error) || 'Could not predict your size right now.');}
document.getElementById('spResultBadge').textContent=result.data.recommendedSize;
document.getElementById('spResultExplanation').textContent=result.data.explanation || '';
document.getElementById('spFormView').style.display='none';
document.getElementById('spResultView').style.display='block';
})
.catch(function(err){
btn.disabled=false;
btn.textContent='Predict My Size';
errorEl.textContent=err.message || 'Something went wrong. Please try again.';
});
}

function resetSizePredictor(){
document.getElementById('spResultView').style.display='none';
document.getElementById('spFormView').style.display='block';
var errorEl=document.getElementById('spError');
if(errorEl){errorEl.textContent='';}
}

function openSearchOverlay(){
var overlay=document.getElementById('searchOverlay');
if(overlay){overlay.classList.add('open');}
document.body.style.overflow='hidden';
var input=document.getElementById('searchOverlayInput');
if(input){setTimeout(function(){input.focus();},50);}
}

function closeSearchOverlay(){
var overlay=document.getElementById('searchOverlay');
if(overlay){overlay.classList.remove('open');}
document.body.style.overflow='';
}

document.addEventListener('keydown',function(e){
if(e.key==='Escape'){
var overlay=document.getElementById('searchOverlay');
if(overlay && overlay.classList.contains('open')){closeSearchOverlay();}
}
});

function renderSearchResults(products,query){
var box=document.getElementById('searchOverlayResults');
if(!box){return;}
var safeQuery=query.replace(/</g,'&lt;');
if(!products.length){
box.innerHTML='<p class="search-overlay-empty">No products found for &ldquo;'+safeQuery+'&rdquo;</p>';
return;
}
box.innerHTML=products.map(function(p){
return '<a href="'+p.url+'" class="search-result-item">'+
'<div class="search-result-img"><img src="'+(p.image||'')+'" alt="" loading="lazy"></div>'+
'<div class="search-result-info"><p class="search-result-title">'+(p.title||'')+'</p><p class="search-result-price">'+(p.price||'')+'</p></div>'+
'</a>';
}).join('')+
'<a href="/search?q='+encodeURIComponent(query)+'" class="search-overlay-viewall">View all results for &ldquo;'+safeQuery+'&rdquo; &rarr;</a>';
}

var searchDebounceTimer=null;
function handleSearchInput(){
var input=document.getElementById('searchOverlayInput');
var box=document.getElementById('searchOverlayResults');
if(!input || !box){return;}
var q=input.value.trim();
clearTimeout(searchDebounceTimer);
if(q.length<2){
box.innerHTML='<p class="search-overlay-hint">Start typing to search products&hellip;</p>';
return;
}
searchDebounceTimer=setTimeout(function(){
fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6')
.then(function(res){return res.json();})
.then(function(data){
var products=(data.resources && data.resources.results && data.resources.results.products)||[];
// Shopify's own search is instant but literal (title/tag substring
// match only) - "something warm" or "office wear" finds nothing even
// when a genuinely matching product exists. Only fall through to the
// AI-powered semantic search when the fast native search came back
// nearly empty, so a normal successful search never pays the extra
// latency or Gemini cost.
if(products.length>=2 || !window.BRACLO_CHAT_API_BASE){
renderSearchResults(products,q);
return;
}
box.innerHTML='<p class="search-overlay-hint">Searching&hellip;</p>';
fetch(window.BRACLO_CHAT_API_BASE+'/api/search/smart?q='+encodeURIComponent(q))
.then(function(r){return r.json();})
.then(function(aiData){
var smartProducts=aiData && aiData.products;
renderSearchResults((smartProducts && smartProducts.length) ? smartProducts : products, q);
})
.catch(function(){
renderSearchResults(products,q);
});
})
.catch(function(){
box.innerHTML='<p class="search-overlay-empty">Something went wrong. Please try again.</p>';
});
},300);
}

function triggerImageSearch(){
var input=document.getElementById('searchImageFileInput');
if(input){input.click();}
}

function triggerCameraSearch(){
var input=document.getElementById('searchCameraFileInput');
if(input){input.click();}
}

// Shared handler for both the gallery-upload and camera-capture file
// inputs above — one Gemini vision call turns the photo into a short text
// description server-side, then it's matched against the catalog exactly
// like a typed AI search (see routes/search.js /api/search/image).
function handleImageSearchFile(file){
if(!file){return;}
var box=document.getElementById('searchOverlayResults');
if(!box){return;}
if(!window.BRACLO_CHAT_API_BASE){
box.innerHTML='<p class="search-overlay-empty">Image search is not available right now.</p>';
return;
}
box.innerHTML='<p class="search-overlay-hint">Analyzing image&hellip;</p>';
var formData=new FormData();
formData.append('image',file);
fetch(window.BRACLO_CHAT_API_BASE+'/api/search/image',{method:'POST',body:formData})
.then(function(res){return res.json().then(function(data){return {ok:res.ok,data:data};});})
.then(function(result){
if(!result.ok){throw new Error((result.data && result.data.error) || 'Something went wrong.');}
var products=result.data.products||[];
var query=result.data.query;
if(!query){
box.innerHTML='<p class="search-overlay-empty">Could not recognise a clothing item in that photo. Please try another one.</p>';
return;
}
renderSearchResults(products,query);
})
.catch(function(err){
box.innerHTML='<p class="search-overlay-empty">'+(err.message || 'Something went wrong. Please try again.')+'</p>';
});
}

var _tierPromise = null;
function getCustomerTierCached() {
if(_tierPromise){return _tierPromise;}
if(!window.bracloAccount || !window.bracloAccount.isLoggedIn || !window.bracloAccount.isLoggedIn()){
_tierPromise = Promise.resolve(null);
return _tierPromise;
}
_tierPromise = window.bracloAccount.accountFetch('/me').then(function(data){
var numericId = data.customer && data.customer.id ? data.customer.id.toString().split('/').pop() : null;
if(!numericId){return null;}
return fetch((window.BRACLO_CHAT_API_BASE||'')+'/api/rewards/balance/'+numericId)
.then(function(r){return r.ok ? r.json() : null;})
.then(function(data2){return data2 && data2.tier ? data2.tier.name : null;});
}).catch(function(){return null;});
return _tierPromise;
}

// Gold Early Access — hides the buy box (PDP + mobile sticky bar) and the
// grid quick-add for any product tagged with a future braclo.early_access_until
// metafield, revealing it only for logged-in Gold-tier customers. This is a
// UX-level gate, not a hard security boundary: the underlying variant is
// still a normal purchasable Shopify product, so it deters casual visitors
// but doesn't stop someone posting directly to /cart/add.js. True
// enforcement isn't available for the same reason B Coins discount codes
// aren't customer-locked — the store's real checkout is the third-party
// Shiprocket/Fastrr widget, which never runs Shopify's own access checks.
//
// The metafield is a date_time field and the merchant sets it to the exact
// moment they want the lock to lift (e.g. "19 Aug, 15:40 IST") - honour
// that instant precisely rather than rounding it to end-of-day.
function earlyAccessCutoffTs(dateTimeStr){
return new Date(dateTimeStr).getTime();
}
function applyEarlyAccessGating(){
var lockedCards = Array.prototype.filter.call(document.querySelectorAll('[data-early-access-until]'), function(el){
var t = earlyAccessCutoffTs(el.dataset.earlyAccessUntil);
return !isNaN(t) && t > Date.now();
});
var pdpPurchaseArea = document.getElementById('pdpPurchaseArea');
var pdpReleaseTs = pdpPurchaseArea && pdpPurchaseArea.dataset.earlyAccessUntil ? earlyAccessCutoffTs(pdpPurchaseArea.dataset.earlyAccessUntil) : null;
var pdpLocked = pdpReleaseTs && !isNaN(pdpReleaseTs) && pdpReleaseTs > Date.now();

if(!lockedCards.length && !pdpLocked){
return;
}

getCustomerTierCached().then(function(tierName){
var isGold = tierName === 'Gold';

lockedCards.forEach(function(card){
if(!isGold){
var form = card.querySelector('.quick-add-form');
if(form){
form.innerHTML = '<a href="/pages/rewards" class="quick-add-btn ea-locked-btn">GOLD EARLY ACCESS</a>';
}
}
});

if(pdpLocked){
var badge = document.getElementById('earlyAccessBadge');
var lockPanel = document.getElementById('earlyAccessLockPanel');
var stickyCart = document.getElementById('mobileStickyCart');
if(isGold){
if(badge){badge.hidden = false;}
}else{
if(lockPanel){
lockPanel.hidden = false;
var dateEl = lockPanel.querySelector('.ea-release-date');
if(dateEl){dateEl.textContent = new Date(pdpReleaseTs).toLocaleDateString('en-IN',{day:'numeric',month:'long',year:'numeric'});}
}
if(pdpPurchaseArea){
pdpPurchaseArea.classList.add('ea-locked');
var submitBtn = pdpPurchaseArea.querySelector('.add-cart-btn-inline');
if(submitBtn){
submitBtn.textContent = 'GOLD EARLY ACCESS';
submitBtn.disabled = true;
submitBtn.classList.add('ea-locked-btn');
}
}
if(stickyCart){
var stickyBtn = stickyCart.querySelector('.mobile-sticky-btn');
if(stickyBtn){
stickyBtn.textContent = 'GOLD EARLY ACCESS';
stickyBtn.disabled = true;
stickyBtn.classList.add('ea-locked-btn');
}
}
}
}
});
}

// Wishlist button shown in place of a locked (Gold Early Access) buy box -
// requires login first, unlike the regular guest-friendly wishlist hearts
// elsewhere, since it's tied to the account-based Gold tier system. Sizes
// stay selectable even while the buy box is locked so the shopper can note
// which size they want; if one's picked, it rides along with the wishlist
// entry so it shows up in the drawer.
function handleLockedWishlistClick(btn){
if(window.bracloAccount && window.bracloAccount.isLoggedIn && window.bracloAccount.isLoggedIn()){
var checkedSize = document.querySelector('#sizeRow .size-radio:checked');
if(checkedSize){
var sizeLabel = document.querySelector('label[for="'+checkedSize.id+'"]');
btn.dataset.wishlistSize = sizeLabel ? sizeLabel.textContent.trim() : checkedSize.value;
}
toggleWishlist(btn);
btn.textContent = 'Added to Wishlist';
btn.disabled = true;
}else{
window.location.href = '/pages/my-account?redirect=' + encodeURIComponent(window.location.pathname);
}
}

// Real serviceability check (COD + estimated delivery date) against the
// seller's own Shiprocket account via chat-api's /api/serviceability route —
// replaces the old client-side-only regex that just format-validated the
// pincode and always showed the same hardcoded "4-6 business days" message.
function checkPincodeServiceability(){
var input=document.getElementById('pincodeInput');
var out=document.getElementById('pincodeResult');
var btn=document.getElementById('pincodeBtn');
if(!input || !out){return;}
var p=input.value.trim();
out.className='pincode-result';
if(!/^[0-9]{6}$/.test(p)){
out.textContent='Please enter a valid 6-digit pincode.';
out.classList.add('error');
return;
}
out.textContent='Checking delivery…';
if(btn){btn.disabled=true;}
fetch((window.BRACLO_CHAT_API_BASE||'')+'/api/serviceability/check?pincode='+p)
.then(function(res){return res.json().then(function(data){return {ok:res.ok,data:data};});})
.then(function(r){
if(!r.ok){throw new Error((r.data && r.data.error) || 'Could not check delivery right now.');}
var data=r.data;
if(!data.serviceable){
out.textContent='Sorry, we currently don\'t deliver to '+p+'.';
out.classList.add('error');
return;
}
var etaText='';
if(data.estimatedDays){
var eta=new Date();
eta.setDate(eta.getDate()+data.estimatedDays);
etaText=' by '+eta.toLocaleDateString('en-IN',{day:'numeric',month:'short'});
}
var codText=data.codAvailable ? 'Cash on Delivery available.' : 'Cash on Delivery not available for this pincode — prepaid only.';
out.innerHTML='&#10003; Delivers to '+p+etaText+'. '+codText;
out.classList.add('ok');
})
.catch(function(err){
out.textContent=err.message || 'Could not check delivery right now. Please try again.';
out.classList.add('error');
})
.finally(function(){
if(btn){btn.disabled=false;}
});
}

function celebrateBurst(x,y){
if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches){return;}
var colors=['#D9930D','#f3d896','#111111','#9a6c08'];
var count=22;
for(var i=0;i<count;i++){
var el=document.createElement('div');
var size=5+Math.random()*5;
var isCircle=Math.random()>0.5;
var color=colors[Math.floor(Math.random()*colors.length)];
el.style.cssText='position:fixed;left:'+x+'px;top:'+y+'px;width:'+size+'px;height:'+(isCircle?size:size*1.8)+'px;background:'+color+';border-radius:'+(isCircle?'50%':'2px')+';pointer-events:none;z-index:9999;';
document.body.appendChild(el);
var angle=Math.random()*Math.PI*2;
var distance=60+Math.random()*90;
var dx=Math.cos(angle)*distance;
var dy=Math.sin(angle)*distance-40;
var rotate=Math.random()*720-360;
var anim=el.animate([
{transform:'translate(0,0) rotate(0deg)',opacity:1},
{transform:'translate('+dx+'px,'+(dy+140)+'px) rotate('+rotate+'deg)',opacity:0}
],{duration:900+Math.random()*400,easing:'cubic-bezier(.16,.84,.44,1)'});
anim.onfinish=(function(target){return function(){target.remove();};})(el);
}
}
window.celebrateBurst=celebrateBurst;

function selectPredictedSize(){
var badge=document.getElementById('spResultBadge');
var size=badge ? badge.textContent.trim().toUpperCase() : '';
var pills=document.querySelectorAll('#sizeRow .size-pill');
var matched=null;
pills.forEach(function(p){
if(!matched && p.textContent.trim().toUpperCase()===size){matched=p;}
});
if(matched){matched.click();}
closeSizePredictor();
}

function closeMobileNav(){
var panel=document.getElementById('mobileNavPanel');
var overlay=document.getElementById('mobileNavOverlay');
if(panel){panel.classList.remove('open');}
if(overlay){overlay.classList.remove('open');}
document.body.style.overflow='';
}

function openCartDrawer(){
var drawer=document.getElementById('cartDrawer');
var overlay=document.getElementById('cartDrawerOverlay');
if(drawer){drawer.classList.add('open');}
if(overlay){overlay.classList.add('open');}
document.body.style.overflow='hidden';
loadCartUpsell();
loadCartRewards();
}

function closeCartDrawer(){
var drawer=document.getElementById('cartDrawer');
var overlay=document.getElementById('cartDrawerOverlay');
if(drawer){drawer.classList.remove('open');}
if(overlay){overlay.classList.remove('open');}
document.body.style.overflow='';
}

// Fires Meta Pixel InitiateCheckout the moment the customer heads to
// checkout — read from data-fb-* attributes rendered by Liquid on the
// checkout link (sections/cart-drawer.liquid) rather than an extra fetch,
// since the link navigates away immediately and fbq's own beacon send
// doesn't need to block that navigation.
function bindCheckoutTracking(){
var btn=document.querySelector('.cart-drawer-checkout-btn');
if(!btn || btn.dataset.fbBound){return;}
btn.dataset.fbBound='1';
btn.addEventListener('click',function(){
if(!window.fbq){return;}
var contentIds=(btn.dataset.fbContentIds||'').split(',').filter(Boolean);
fbq('track','InitiateCheckout',{
value:parseFloat(btn.dataset.fbValue)||0,
currency:btn.dataset.fbCurrency||'INR',
num_items:parseInt(btn.dataset.fbNumItems,10)||0,
content_ids:contentIds,
content_type:'product'
});
});
}

function bindCartDrawerEvents(){
var drawer=document.getElementById('cartDrawer');
if(!drawer){return;}
drawer.querySelectorAll('.cart-drawer-qty-select').forEach(function(sel){
sel.addEventListener('change',function(){
var quantity=parseInt(sel.value,10);
if(quantity===0){
var itemEl=sel.closest('.cart-drawer-item');
if(itemEl){itemEl.remove();}
}
changeCartItem(sel.dataset.key,quantity);
});
});
bindCheckoutTracking();
}

function getFormButtons(form){
var buttons=Array.from(form.querySelectorAll('button[type="submit"]'));
if(form.id){
buttons=buttons.concat(Array.from(document.querySelectorAll('button[form="'+form.id+'"]')));
}
return buttons;
}

function animateAddButton(button){
if(!button){return;}
// Grid quick-add buttons are icon-only (bag + checkmark SVGs already both
// present, toggled by the .added class via CSS) - unlike the text-button
// path below, this never touches innerHTML, so the bag icon survives every
// subsequent add instead of being replaced by an empty label after the
// first click.
if(button.classList.contains('quick-add-btn') && button.querySelector('.quick-add-icon-bag')){
button.classList.add('added');
button.disabled=true;
return;
}
// PDP add-to-bag button cycles between "Add to Bag" and a "Try Risk-Free /
// 60-Day Easy Returns" state (see the .cart-cycle-state spans + CSS
// animation in main-product.liquid) - same reasoning as the quick-add
// button above: touching innerHTML here would permanently wipe that markup
// out on the very first click, so just freeze it via the .added class,
// which CSS uses to hide both cycling states and reveal the checkmark one.
if(button.classList.contains('cart-cycle-btn')){
button.classList.add('added');
button.disabled=true;
return;
}
if(!button.querySelector('.btn-label-wrap')){
var originalText=button.textContent.trim();
button.innerHTML=
'<span class="btn-label-wrap">'+
'<span class="btn-label btn-label-default">'+originalText+'</span>'+
'<span class="btn-label btn-label-success"><svg class="btn-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>Added to Bag</span>'+
'</span>';
}
button.classList.add('added');
button.disabled=true;
}

function resetAddButton(button){
if(!button){return;}
button.classList.remove('added');
button.disabled=false;
}

// Fires Meta Pixel AddToCart using the real line the customer just added
// (variant id/price/quantity come straight back from Shopify's own
// /cart/add.js response, so this can't drift out of sync with the cart).
function trackAddToCart(item){
if(!window.fbq || !item){return;}
fbq('track','AddToCart',{
content_ids:[String(item.variant_id || item.id)],
content_type:'product',
value:(item.final_price || item.price || 0)/100,
currency:(window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR',
contents:[{id:String(item.variant_id || item.id), quantity:item.quantity||1}]
});
}

function addToCartAjax(form){
var buttons=getFormButtons(form);
buttons.forEach(animateAddButton);
var formData=new FormData(form);
var addPromise=fetch('/cart/add.js',{method:'POST',body:formData,headers:{'Accept':'application/json'}})
.then(function(res){
if(!res.ok){throw new Error('add failed');}
return res.json();
});
var minDelay=new Promise(function(resolve){setTimeout(resolve,650);});
Promise.all([addPromise,minDelay])
.then(function(results){
trackAddToCart(results[0]);
refreshCartDrawer();
openCartDrawer();
setTimeout(function(){buttons.forEach(resetAddButton);},400);
})
.catch(function(){
buttons.forEach(resetAddButton);
form.submit();
});
}

function changeCartItem(key,quantity){
fetch('/cart/change.js',{
method:'POST',
headers:{'Content-Type':'application/json','Accept':'application/json'},
body:JSON.stringify({id:key,quantity:quantity})
})
.then(function(){return refreshCartDrawer();});
}

function refreshCartDrawer(){
return fetch(window.location.pathname+'?sections=cart-drawer')
.then(function(res){return res.json();})
.then(function(data){
var html=data['cart-drawer'];
if(!html){return;}
var temp=document.createElement('div');
temp.innerHTML=html;
var newDrawer=temp.querySelector('#cartDrawer');
var oldDrawer=document.getElementById('cartDrawer');
if(newDrawer && oldDrawer){
oldDrawer.innerHTML=newDrawer.innerHTML;
bindCartDrawerEvents();
}
})
.then(function(){return fetch('/cart.js');})
.then(function(res){return res.json();})
.then(function(cart){
document.querySelectorAll('.cart-count:not(.wishlist-count)').forEach(function(el){
el.textContent=cart.item_count;
el.style.display = cart.item_count > 0 ? '' : 'none';
});
loadCartUpsell();
loadCartRewards();
snapshotAbandonedCart(cart);
});
}

/* Abandoned cart recovery snapshot - posts the current cart to the backend
   whenever it changes, but only for logged-in customers (we need an email
   to send a recovery email to; guests have none to reach). Debounced so a
   burst of quantity changes doesn't fire a request per keystroke/click. The
   backend restarts its own 1-hour reminder countdown on every snapshot. */
var abandonedCartSnapshotTimer=null;
function snapshotAbandonedCart(cart){
if(!window.bracloAccount || !window.bracloAccount.isLoggedIn || !window.bracloAccount.isLoggedIn()){ return; }
var email=window.bracloAccount.getCustomerEmail && window.bracloAccount.getCustomerEmail();
if(!email){ return; }
if(abandonedCartSnapshotTimer){ clearTimeout(abandonedCartSnapshotTimer); }
abandonedCartSnapshotTimer=setTimeout(function(){
var items=(cart.items||[]).map(function(item){
return {
variantId:item.variant_id,
title:item.product_title,
quantity:item.quantity,
price:item.final_price/100,
image:item.image
};
});
fetch('https://chat-api.braclo.in/api/abandoned-cart/snapshot',{
method:'POST',
headers:{'Content-Type':'application/json'},
body:JSON.stringify({email:email, items:items})
}).catch(function(){});
},1500);
}

/* Braclo Rewards redemption in the cart drawer — lives here (not on the
   Shopify checkout page) because the store's checkout button is intercepted by
   the Shiprocket/Fastrr headless checkout (see snippets/sr-checkout.liquid),
   which bypasses Shopify's native checkout/discount-calculation entirely, so
   Shopify Functions and Checkout UI Extensions never get a chance to run.
   Instead this generates a real, single-use, customer-locked Shopify discount
   code that the customer copies and pastes into Shiprocket's own checkout
   discount field - the one redemption path that still works regardless of
   which checkout UI actually processes the order. */
function loadCartRewards(){
var el=document.getElementById('cartDrawerRewards');
if(!el){ return; }
if(!window.BRACLO_CUSTOMER_ID){
el.innerHTML='<a href="/pages/my-account" class="cart-drawer-rewards-nudge">Sign in to earn B Coins on this order &rarr;</a>';
return;
}
if(!window.BRACLO_CHAT_API_BASE){ el.innerHTML=''; return; }
var customerId=window.BRACLO_CUSTOMER_ID.toString().split('/').pop();
// The balance/redeem endpoints now require the caller's own session token
// (previously they trusted a plain customerId with no auth at all - anyone
// could read or drain any customer's B Coins by passing a different id).
var authToken=window.bracloAccount && window.bracloAccount.getToken ? window.bracloAccount.getToken() : null;
if(!authToken){ el.innerHTML=''; return; }
Promise.all([
fetch(window.BRACLO_CHAT_API_BASE+'/api/rewards/balance/'+customerId,{headers:{'Authorization':'Bearer '+authToken}})
.then(function(r){return r.ok ? r.json() : {balance:0};})
.catch(function(){return {balance:0};}),
fetch('/cart.js').then(function(r){return r.json();})
]).then(function(results){
var balance=results[0].balance||0;
var cart=results[1];
if(balance<=0){el.innerHTML='';return;}
var subtotalRupees=cart.total_price/100;
var redeemable=Math.min(balance, Math.floor(subtotalRupees*0.5));
if(redeemable<=0){el.innerHTML='';return;}
el.innerHTML=
'<button type="button" class="cart-drawer-rewards-toggle" id="cartRewardsBtn">'+
'<svg class="cart-rewards-coin" viewBox="0 0 24 24" aria-hidden="true">'+
'<circle cx="12" cy="12" r="10" fill="url(#cartRewardsCoinGrad)"/>'+
'<text x="12" y="16.5" text-anchor="middle" font-size="11" font-weight="700" fill="#5c3d06">B</text>'+
'<defs><radialGradient id="cartRewardsCoinGrad" cx="35%" cy="30%" r="75%">'+
'<stop offset="0%" stop-color="#fdf0c8"/><stop offset="45%" stop-color="#eab63c"/><stop offset="100%" stop-color="#8a5c0a"/>'+
'</radialGradient></defs>'+
'</svg>'+
'<span>Redeem '+balance+' B Coins &mdash; get &#8377;'+redeemable+' off</span>'+
'</button>'+
'<div class="cart-drawer-rewards-error" id="cartRewardsError" hidden></div>';
var btn=document.getElementById('cartRewardsBtn');
btn.addEventListener('click',function(){
btn.disabled=true;
btn.classList.add('loading');
btn.querySelector('span').textContent='Generating your code...';
var errorEl=document.getElementById('cartRewardsError');
errorEl.hidden=true;
fetch(window.BRACLO_CHAT_API_BASE+'/api/rewards/redeem',{
method:'POST',
headers:{'Content-Type':'application/json','Authorization':'Bearer '+authToken},
body:JSON.stringify({cartSubtotal:subtotalRupees})
})
.then(function(res){return res.json().then(function(data){ return {ok:res.ok, data:data}; });})
.then(function(result){
if(!result.ok){ throw new Error(result.data.error || 'Something went wrong.'); }
el.innerHTML=
'<div class="cart-drawer-rewards-code">'+
'<span>Code applied &#8377;'+result.data.amount+' off &mdash; paste this at checkout:</span>'+
'<div class="cart-drawer-rewards-code-row">'+
'<code id="cartRewardsCodeText">'+result.data.code+'</code>'+
'<button type="button" id="cartRewardsCopyBtn">Copy</button>'+
'</div>'+
'</div>';
document.getElementById('cartRewardsCopyBtn').addEventListener('click',function(){
navigator.clipboard.writeText(result.data.code).then(function(){
var copyBtn=document.getElementById('cartRewardsCopyBtn');
copyBtn.textContent='Copied!';
setTimeout(function(){copyBtn.textContent='Copy';},1500);
});
});
})
.catch(function(err){
btn.disabled=false;
btn.classList.remove('loading');
btn.querySelector('span').textContent='Redeem '+balance+' B Coins — get ₹'+redeemable+' off';
errorEl.textContent=err.message;
errorEl.hidden=false;
});
});
}).catch(function(){el.innerHTML='';});
}

var upsellVariantsMap={};

function normalizeVariants(rawVariants){
return (rawVariants||[]).map(function(v){
return {id:v.id, title:v.title, available: v.available!==false};
});
}

function normalizeRecommendation(p){
return {
id:String(p.id),
title:p.title,
url:p.url || ('/products/'+p.handle),
image:(p.images && p.images[0]) || '',
price:(typeof p.price==='number') ? p.price/100 : 0,
variants: normalizeVariants(p.variants)
};
}

function normalizeCatalogProduct(p){
var variant=(p.variants && p.variants[0]) || {};
var img=(p.images && p.images[0] && p.images[0].src) || '';
return {
id:String(p.id),
title:p.title,
url:'/products/'+p.handle,
image:img,
price: variant.price ? parseFloat(variant.price) : 0,
variants: normalizeVariants(p.variants)
};
}

function renderUpsell(products){
var grid=document.getElementById('cartDrawerUpsellGrid');
if(!grid || !products.length){return;}
upsellVariantsMap={};
grid.innerHTML=products.map(function(p){
upsellVariantsMap[p.id]=p.variants||[];
var price=p.price.toLocaleString('en-IN',{style:'currency',currency:'INR',minimumFractionDigits:0});
return '<div class="cart-drawer-upsell-card">'+
'<a href="'+p.url+'" class="cart-drawer-upsell-link">'+
'<div class="cart-drawer-upsell-image"><img src="'+p.image+'" alt="'+(p.title||'').replace(/"/g,'&quot;')+'" loading="lazy"></div>'+
'<p class="cart-drawer-upsell-name">'+p.title+'</p>'+
'<p class="cart-drawer-upsell-price">'+price+'</p>'+
'</a>'+
'<div class="cart-drawer-upsell-action" data-product-id="'+p.id+'">'+
'<button type="button" class="cart-drawer-upsell-add-btn">+ Add</button>'+
'</div>'+
'</div>';
}).join('');
bindUpsellAddButtons();
}

function bindUpsellAddButtons(){
var grid=document.getElementById('cartDrawerUpsellGrid');
if(!grid){return;}
grid.querySelectorAll('.cart-drawer-upsell-add-btn').forEach(function(btn){
btn.addEventListener('click',function(){
var actionEl=btn.closest('.cart-drawer-upsell-action');
var pid=actionEl.dataset.productId;
var variants=upsellVariantsMap[pid]||[];
var available=variants.filter(function(v){return v.available;});
if(variants.length<=1){
var only=available[0]||variants[0];
if(only){addUpsellVariant(only.id, actionEl);}
return;
}
showUpsellSizePicker(actionEl, available.length?available:variants);
});
});
}

function showUpsellSizePicker(actionEl, variants){
var select=document.createElement('select');
select.className='cart-drawer-upsell-size-select';
var placeholder=document.createElement('option');
placeholder.textContent='Size';
placeholder.value='';
select.appendChild(placeholder);
variants.forEach(function(v){
var opt=document.createElement('option');
opt.value=v.id;
opt.textContent=v.title;
select.appendChild(opt);
});
actionEl.innerHTML='';
actionEl.appendChild(select);
select.addEventListener('change',function(){
if(select.value){addUpsellVariant(select.value, actionEl);}
});
}

function addUpsellVariant(variantId, actionEl){
actionEl.innerHTML='<span class="cart-drawer-upsell-adding">Adding…</span>';
fetch('/cart/add.js',{
method:'POST',
headers:{'Content-Type':'application/json','Accept':'application/json'},
body:JSON.stringify({items:[{id:variantId, quantity:1}]})
})
.then(function(res){
if(!res.ok){throw new Error('add failed');}
return res.json();
})
.then(function(data){
var addedItem=(data.items && data.items[0]) || data;
trackAddToCart(addedItem);
return refreshCartDrawer();
})
.catch(function(){
actionEl.innerHTML='<button type="button" class="cart-drawer-upsell-add-btn">+ Add</button>';
bindUpsellAddButtons();
});
}

function loadCartUpsell(){
var el=document.getElementById('cartDrawerUpsell');
if(!el){return;}
var cartIds=Array.from(new Set((el.dataset.productIds||'').split(',').filter(Boolean)));
if(!cartIds.length){return;}

var recRequests=cartIds.slice(0,3).map(function(pid){
return fetch('/recommendations/products.json?product_id='+pid+'&limit=6&intent=complementary')
.then(function(res){return res.ok ? res.json() : {products:[]};})
.catch(function(){return {products:[]};});
});

Promise.all(recRequests).then(function(results){
var seen={};
var merged=[];
results.forEach(function(data){
(data.products||[]).forEach(function(raw){
var p=normalizeRecommendation(raw);
if(!seen[p.id] && cartIds.indexOf(p.id)===-1){
seen[p.id]=true;
merged.push(p);
}
});
});

if(merged.length>=6){
renderUpsell(merged.slice(0,6));
return;
}

fetch('/products.json?limit=100')
.then(function(res){return res.json();})
.then(function(data){
var pool=(data.products||[])
.map(normalizeCatalogProduct)
.filter(function(p){return cartIds.indexOf(p.id)===-1 && !seen[p.id];});
for(var i=pool.length-1;i>0;i--){
var j=Math.floor(Math.random()*(i+1));
var tmp=pool[i];pool[i]=pool[j];pool[j]=tmp;
}
var needed=6-merged.length;
renderUpsell(merged.concat(pool.slice(0,needed)));
})
.catch(function(){renderUpsell(merged);});
});
}

function getWishlist(){
try{ return JSON.parse(localStorage.getItem('braclo_wishlist') || '[]'); }
catch(e){ return []; }
}

function saveWishlist(list){
localStorage.setItem('braclo_wishlist', JSON.stringify(list));
updateWishlistCount();
}

function toggleWishlist(btn){
var id=btn.dataset.wishlistId;
var list=getWishlist();
var idx=list.findIndex(function(item){ return item.id===id; });
if(idx>-1){
list.splice(idx,1);
btn.classList.remove('active');
}else{
list.push({
id:id,
title:btn.dataset.wishlistTitle,
url:btn.dataset.wishlistUrl,
image:btn.dataset.wishlistImage,
price:btn.dataset.wishlistPrice,
size:btn.dataset.wishlistSize || null
});
btn.classList.add('active');
}
saveWishlist(list);
renderWishlistDrawer();
}

function markWishlistIcons(){
var ids=getWishlist().map(function(item){ return item.id; });
document.querySelectorAll('.wishlist-heart').forEach(function(btn){
if(ids.indexOf(btn.dataset.wishlistId)>-1){ btn.classList.add('active'); }
});
}

function updateWishlistCount(){
var count=getWishlist().length;
document.querySelectorAll('.wishlist-count').forEach(function(el){
el.textContent=count;
if(el.classList.contains('cart-count')){
el.style.display = count > 0 ? '' : 'none';
}
});
}

function openWishlistDrawer(){
var drawer=document.getElementById('wishlistDrawer');
var overlay=document.getElementById('wishlistDrawerOverlay');
if(drawer){drawer.classList.add('open');}
if(overlay){overlay.classList.add('open');}
document.body.style.overflow='hidden';
renderWishlistDrawer();
}

function closeWishlistDrawer(){
var drawer=document.getElementById('wishlistDrawer');
var overlay=document.getElementById('wishlistDrawerOverlay');
if(drawer){drawer.classList.remove('open');}
if(overlay){overlay.classList.remove('open');}
document.body.style.overflow='';
}

function removeFromWishlist(id){
var list=getWishlist().filter(function(item){ return item.id!==id; });
saveWishlist(list);
document.querySelectorAll('.wishlist-heart[data-wishlist-id="'+id+'"]').forEach(function(btn){ btn.classList.remove('active'); });
renderWishlistDrawer();
}

function renderWishlistDrawer(){
var grid=document.getElementById('wishlistDrawerGrid');
var empty=document.getElementById('wishlistDrawerEmpty');
if(!grid){return;}
var list=getWishlist();
if(list.length===0){
grid.innerHTML='';
if(empty){empty.style.display='block';}
return;
}
if(empty){empty.style.display='none';}
grid.innerHTML=list.map(function(item){
return '<div class="wishlist-drawer-item">'+
'<a href="'+item.url+'" class="wishlist-drawer-item-image"><img src="'+item.image+'" alt="'+(item.title||'').replace(/"/g,'&quot;')+'" loading="lazy"></a>'+
'<div class="wishlist-drawer-item-info">'+
'<h4><a href="'+item.url+'">'+item.title+'</a></h4>'+
(item.size ? '<p class="wishlist-drawer-item-size">Size: '+item.size+'</p>' : '')+
'<p class="wishlist-drawer-item-price">'+item.price+'</p>'+
'</div>'+
'<button type="button" class="wishlist-drawer-remove" onclick="removeFromWishlist(\''+item.id+'\')" aria-label="Remove">&times;</button>'+
'</div>';
}).join('');
}

function handleQuickAdd(form){
if(form.dataset.sizeMode==='1'){return;}
var variants=[];
try{ variants=JSON.parse(form.dataset.variants||'[]'); }catch(e){ variants=[]; }
var realSizes=variants.filter(function(v){return v.title && v.title!=='Default Title';});
if(variants.length>1 && realSizes.length>0){
showQuickAddSizePicker(form,variants);
return;
}
addToCartAjax(form);
}

function showQuickAddSizePicker(form,variants){
var btn=form.querySelector('.quick-add-btn');
if(!btn){return;}
form.dataset.sizeMode='1';
var select=document.createElement('select');
select.className='quick-add-size-select';
var placeholder=document.createElement('option');
placeholder.textContent='SELECT SIZE';
placeholder.value='';
select.appendChild(placeholder);
variants.forEach(function(v){
var opt=document.createElement('option');
opt.value=v.id;
opt.textContent=v.available? v.title : v.title+' (Sold out)';
opt.disabled=!v.available;
select.appendChild(opt);
});
btn.replaceWith(select);
select.addEventListener('change',function(){
if(!select.value){return;}
var hiddenInput=form.querySelector('input[name="id"]');
if(hiddenInput){hiddenInput.value=select.value;}
addToCartAjax(form);
});
}
